import React from 'react'
import { FireMembership } from 'assets/icons'

interface TagProps {
  children: React.ReactNode
  className?: string
}

const Tag = ({ children, className = '' }: TagProps) => (
  <div
    className={`text-center text-2xs font-bold text-[#1E3C66] w-fit bg-blue-100 rounded-lg p-2 ${className}`}
  >
    {children}
  </div>
)

export default Tag

interface MembershipTagProps {
  className?: string
  text: string | JSX.Element
}

export const MembershipTag = ({ text, className = '' }: MembershipTagProps) => (
  <span
    className={`flex py-1 px-2 text-2xs w-fit items-center gap-2 bg-green-100 rounded-lg ${className}`}
  >
    <FireMembership className='!stroke-[#08724C]' />
    <span className='font-bold text-[#08724C]'>{text}</span>
  </span>
)
